var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPortalArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.75 15.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 216",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3447",
    d: "M3.419 4.55V.75h8.582v14H3.419v-3.834"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3448",
    d: "M0 7.751h9.027"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3449",
    d: "M6.015 4.738L9.027 7.75l-3.012 3.012"
  }))))));
}

export default __webpack_public_path__ + "07500e320e55d04f9237c569d47c16fd.svg";
export { SvgPortalArrow as ReactComponent };